const HTML_ESCAPES = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
};

/**
 * Escapes text destined for a v-html sink.
 *
 * ConfirmModal and a handful of other components render their input with v-html, so any caller that
 * interpolates a value it did not author — a sensor name, a company name, anything that reached us
 * from a customer or a vendor sync — is handing that value script execution inside the portal, for
 * the operator who holds the most privilege in the product. Escape at the point the string is built;
 * the sink cannot tell which parts of its input were meant as markup.
 */
export function escapeHtml(value) {
    return String(value ?? '').replace(/[&<>"']/g, character => HTML_ESCAPES[character]);
}
